import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=497bf1ce&scoped=true&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&id=497bf1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf1ce",
  null
  
)

export default component.exports